/****************************************************
 * Module Name:  hnaProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class HNAProxy {
  static GetAllHNA = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/hna",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleHNA = (hnaId, callback) => {
    let params = {
      id: hnaId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/hna",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckHNAAvailable = (hna, callback) => {
    let params = {
      hna: hna,
    };

    restAPICall(
      Constants.MANAGER_URL + "/hna/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddHNA = (hna, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/hna",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(hna),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateHNA = (hna, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/hna",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(hna),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteHNA = (hna, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/hna",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(hna),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
